import React from 'react'
import ContextMenuItem from './ContextMenuItem'
import { ITINERAIRE_DEPUIS } from './contextmenu.constants'
import { useT } from '../../i18n/T'
import { useAction, withEverySelectorTruthy } from '../../utils/react-redux'
import { setDepartureFromPoint } from '../../../store/itinerary/itinerary.actions'
import { selectIsItineraryUniverse } from '../../../store/history/history.selectors'

const ContextMenuItemItineraryFrom = () => {
  const label = useT('map.context-menu.go-from-itinerary')
  const execSetDepartureFromPoint = useAction(setDepartureFromPoint)

  const onItineraryFrom = point => {
    execSetDepartureFromPoint(point).catch(e => console.error(e))
  }

  return <ContextMenuItem tagAction={ITINERAIRE_DEPUIS} label={label} clickAction={onItineraryFrom} />
}

export default withEverySelectorTruthy(selectIsItineraryUniverse)(ContextMenuItemItineraryFrom)
